export const SYNC_STATUS_COMPLETED = "COMPLETED";
export const SYNC_STATUS_FAILED = "FAILED";
export const SYNC_STATUS_RUNNING = "RUNNING";
